export default __webpack_public_path__ + "static/media/logoRIESCO.21a47050.png";